import * as React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import { Typography, Box, Container, TextField, CssBaseline, Button, Select, MenuItem, InputLabel, FormHelperText, FormControl, CircularProgress, Chip, Tooltip, Paper, Stack, Divider, Radio, RadioGroup, Alert } from '@mui/material';
import { connect } from "react-redux";
import { centered_flex_box, MainInput, MainInputLabel, MainTextArea, main_button, reject_button, sec_button, StyledInput } from '../../app/components/Styles';
import { useNavigate, useParams } from 'react-router-dom';
import ReactFileReader from 'react-file-reader';
import { editEvent, getEvent } from '../../app/store/actions/eventActions';
import { getWhatsappTemplates } from '../../app/store/actions/adminActions';
import { config } from "../../app/config";
import moment from 'moment';
import { uploadFile } from '../../core/aws';
import {
    WhatsappEventTemplatePicker,
    resolveWhatsappTemplateField,
    deriveInitialWhatsappField,
} from './WhatsappEventTemplatePickers';
import {
    marketingColors,
    marketingFonts,
    eventSurfacePaperSx,
    primaryButtonSx,
    eventOutlinedButtonSx,
    eventSectionTitleSx,
} from '../../app/components/tickitMarketingTheme';
import {
    PlatformPage,
    PlatformPageHeader,
    PlatformCard,
    PlatformButton,
    PlatformLoadingBlock,
} from '../../app/components/platform';
import { platformColors } from '../../app/components/tickitPlatformTheme';

/** HTML datetime-local expects local wall time as YYYY-MM-DDTHH:mm (string, not a Moment). */
function toDatetimeLocalValue(value) {
    if (value == null || value === '') return '';
    const m = moment(value);
    return m.isValid() ? m.format('YYYY-MM-DDTHH:mm') : '';
}

export const EditEvent = ({ editEvent, getEvent, getWhatsappTemplates, templates, isLoading, isGetLoading, event }) => {
    window.Buffer = window.Buffer || require("buffer").Buffer;

    const id = useParams().id

    React.useEffect(() => {
        getEvent({ eventId: id })
    }, [id])

    React.useEffect(() => {
        getWhatsappTemplates && getWhatsappTemplates({ page: 1, limit: 100, search: "" });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const navigate = useNavigate()
    const [file, setFile] = React.useState(null);


    const [extraInfo, setExtraInfo] = React.useState(event?.moreInfo?.length);
    const [categories, setCategories] = React.useState(event?.categories?.length);
    const [image, setImage] = React.useState(null);
    const [coverImage, setCoverImage] = React.useState(null);
    const [sponsorsImage, setSponsorsImage] = React.useState(null);
    const [chart, setChart] = React.useState(null);
    const [paymentMethod, setPaymentMethod] = React.useState(event?.paymentMethod);
    const [corporate, setCorporate] = React.useState(false);
    const [byRequest, setByRequest] = React.useState(false);
    const [directInvitation, setDirectInvitation] = React.useState(false);
    const [autoAccept, setAutoAccept] = React.useState(false);
    const [isPublic, setIsPublic] = React.useState(false);
    const [hasAttachment, setHasAttachment] = React.useState(false);
    const [attachment, setAttachment] = React.useState(null);
    const [waRsvp, setWaRsvp] = React.useState({ sel: "", custom: "" });
    const [waQr, setWaQr] = React.useState({ sel: "", custom: "" });
    const [waPlusOne, setWaPlusOne] = React.useState({ sel: "", custom: "" });
    const [waReminder, setWaReminder] = React.useState({ sel: "", custom: "" });
    const [waRejection, setWaRejection] = React.useState({ sel: "", custom: "" });
    const [waAttachment, setWaAttachment] = React.useState({ sel: "", custom: "" });

    React.useEffect(() => {
        if (!event) return;
        setCorporate(!!event.corporate);
        setByRequest(!!event.byRequest);
        setDirectInvitation(!!event.directInvitation);
        setAutoAccept(!!event.autoAccept);
        setIsPublic(!!event.public);
        setPaymentMethod(event.paymentMethod);
        setHasAttachment(!!event.hasAttachment);
        const docs = templates?.docs;
        if (!docs) return;
        setWaRsvp(deriveInitialWhatsappField(event.whatsappRSVPTemplate, docs));
        setWaQr(deriveInitialWhatsappField(event.whatsappQRTemplate, docs));
        setWaPlusOne(deriveInitialWhatsappField(event.whatsappPlusOneTemplate, docs));
        setWaReminder(deriveInitialWhatsappField(event.whatsappReminderTemplate, docs));
        setWaRejection(deriveInitialWhatsappField(event.whatsappRejectionResponseTemplate, docs));
        setWaAttachment(deriveInitialWhatsappField(event.whatsappAttachmentTemplate, docs));
    }, [event, templates]);

    const handlePaymentMethod = (event) => {
        const value = event.target.value;
        setPaymentMethod(value);
        if (value === "Cash" || value === "InstaPay") {
            setByRequest(true);
            setCorporate(false);
        }
    };

    const ticketFlow = corporate
        ? "invitation"
        : directInvitation
        ? "directInvitation"
        : byRequest
        ? "registration"
        : "direct";

    const handleTicketFlowChange = (event) => {
        const flow = event.target.value;
        if (flow === "direct") {
            setByRequest(false);
            setCorporate(false);
            setDirectInvitation(false);
        } else if (flow === "registration") {
            setByRequest(true);
            setCorporate(false);
            setDirectInvitation(false);
        } else if (flow === "invitation") {
            setByRequest(false);
            setCorporate(true);
            setDirectInvitation(false);
        } else if (flow === "directInvitation") {
            setByRequest(false);
            setCorporate(false);
            setDirectInvitation(true);
        }
    };

    const handleAdd = (event) => {
        setExtraInfo(extraInfo + 1)
    }

    const handleRemove = (event) => {
        if (extraInfo > 0) {
            setExtraInfo(extraInfo - 1)
        }
    }

    const handleAddCat = (event) => {
        setCategories(categories + 1)
    }

    const handleRemoveCat = (event) => {
        if (categories > 1) {
            setCategories(categories - 1)
        }
    }

    const handleAddImage = files => {
        let file = files[0]
        console.log(file)
        setImage(file)
    }

    const handleDeleteImage = () => {
        setImage(null);
    }

    const handleAddCoverImage = files => {
        let file = files[0]
        console.log(file)
        setCoverImage(file)
    }

    const handleDeleteCoverImage = () => {
        setCoverImage(null);
    }

    const handleAddSponsorsImage = files => {
        let file = files[0]
        console.log(file)
        setSponsorsImage(file)
    }

    const handleDeleteSponsorsImage = () => {
        setSponsorsImage(null);
    }

    const handleAddChart = files => {
        let file = files[0]
        console.log(file)
        setChart(file)
    }

    const handleDeleteChart = () => {
        setChart(null);
    }

    const handleAddAttachment = (files) => {
        let f = files[0];
        setAttachment(f);
    };

    const handleDeleteAttachment = () => {
        setAttachment(null);
    };

    const handleSubmit = async (ev) => {
        ev.preventDefault();
        const data = new FormData(ev.currentTarget);
        try {
            var imageUrl
            var coverImageUrl
            var sponsorsImageUrl
            var chartUrl
            var categoriesList = []
            var moreInfo = []
            if (image) {
                imageUrl = await uploadFile(image)
            }
            if (coverImage) {
                coverImageUrl = await uploadFile(coverImage)
            }
            if (sponsorsImage) {
                sponsorsImageUrl = await uploadFile(sponsorsImage)
            }
            if (chart) {
                chartUrl = await uploadFile(chart)
            }
            for (let i = 0; i < extraInfo; i++) {
                moreInfo.push(data.get(`req${i}`))
            }
            for (let i = 0; i < categories; i++) {
                categoriesList.push({ category: data.get(`cat${i}`), price: parseInt(data.get(`cat${i}Price`)), amount: parseInt(data.get(`cat${i}Tickets`)), sold: event?.categories[i] ? event.categories[i].sold : 0, available: data.get(`cat${i}Available`), sent: event?.categories[i] ? event.categories[i].sent : 0 })
            }

            const updates = {
                image: imageUrl,
                coverImage: coverImageUrl,
                sponsorsImage: sponsorsImageUrl,
                title: data.get("title"),
                description: data.get("description"),
                terms: data.get("terms"),
                artist: data.get("artist"),
                date: data.get("date") === "" ? undefined : moment(data.get("date")),
                location: data.get("location"),
                seatChart: chartUrl,
                categories: categoriesList,
                deadline: data.get("deadline") === "" ? undefined : moment(data.get("deadline")),
                public: isPublic,
                moreInfo: moreInfo,
                needsVerification: data.get("needsVerification") === "on",
                byRequest: byRequest,
                autoAccept: byRequest ? autoAccept : false,
                directInvitation: directInvitation,
                gatesOpenAt: data.get("gatesOpenAt") === "" ? undefined : moment(data.get("gatesOpenAt")),
                locationURL: data.get("locationURL"),
                paymentMethod,
                paymentAddress: paymentMethod === "Cash" ? data.get("paymentAddress").split(",") : data.get("paymentAddress"),
                corporate,
            }

            if (corporate) {
                updates.organizer = data.get("organizer");
                updates.message = data.get("message");
                updates.hasAttachment = hasAttachment;
                if (hasAttachment) {
                    updates.attachmentTitle = data.get("attachmentTitle") || "";
                    updates.attachment = attachment
                        ? await uploadFile(attachment)
                        : event?.attachment;
                } else {
                    updates.attachment = null;
                    updates.attachmentTitle = "";
                }
                updates.whatsappRSVPTemplate = resolveWhatsappTemplateField(waRsvp.sel, waRsvp.custom);
                updates.whatsappQRTemplate = resolveWhatsappTemplateField(waQr.sel, waQr.custom);
                updates.whatsappPlusOneTemplate = resolveWhatsappTemplateField(waPlusOne.sel, waPlusOne.custom);
                updates.whatsappReminderTemplate = resolveWhatsappTemplateField(waReminder.sel, waReminder.custom);
                updates.whatsappRejectionResponseTemplate = resolveWhatsappTemplateField(waRejection.sel, waRejection.custom);
                updates.whatsappAttachmentTemplate = hasAttachment
                    ? resolveWhatsappTemplateField(waAttachment.sel, waAttachment.custom)
                    : null;
            } else {
                updates.whatsappRSVPTemplate = null;
                updates.whatsappQRTemplate = null;
                updates.whatsappPlusOneTemplate = null;
                updates.whatsappReminderTemplate = null;
                updates.whatsappRejectionResponseTemplate = null;
                updates.whatsappAttachmentTemplate = null;
            }

            editEvent({ updates: updates, eventId: id }, navigate);
        } catch (err) {
            console.log(err)
        }
    };

    const generateRequirements = () => {
        var items = []
        for (let i = 0; i < extraInfo; i++) {
            items.push(
                <Box>
                    <MainInput
                        margin="normal"
                        required
                        fullWidth
                        id={`req${i}`}
                        label="Requirement"
                        name={`req${i}`}
                        defaultValue={event.moreInfo[i]}
                    />
                </Box>
            )
        }
        if (extraInfo > 0) {
            items.push(<Button onClick={handleRemove}>Remove</Button>)
        }
        return items
    }

    const generateCategories = () => {
        var items = []
        for (let i = 0; i < categories; i++) {
            items.push(
                <Grid container>
                    <Grid item xs={3}>
                        <MainInput
                            margin="normal"
                            required
                            id={`cat${i}`}
                            label="Category"
                            name={`cat${i}`}
                            defaultValue={event.categories[i]?.category}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <MainInput
                            margin="normal"
                            required
                            type="number"
                            id={`cat${i}Price`}
                            label="Price"
                            name={`cat${i}Price`}
                            defaultValue={event.categories[i]?.price}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <MainInput
                            margin="normal"
                            required
                            type="number"
                            id={`cat${i}Tickets`}
                            label="Number of Tickets"
                            name={`cat${i}Tickets`}
                            defaultValue={event.categories[i]?.amount}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <MainInput
                            margin="normal"
                            autoFocus
                            select
                            fullWidth
                            labelId='num-label'
                            id={`cat${i}Available`}
                            label="Available for Purchase?"
                            defaultValue={event.categories[i]?.available || true}
                            name={`cat${i}Available`}
                        >
                            <MenuItem value={true}>True</MenuItem>
                            <MenuItem value={false}>False</MenuItem>
                        </MainInput>
                    </Grid>
                </Grid>
            )
        }
        if (categories > 1) {
            items.push(<Button sx={{ ...reject_button, mr: 2 }} onClick={handleRemoveCat}>Remove</Button>)
        }
        return items
    }

    if (isGetLoading || !event?._id) {
        return (
            <PlatformPage maxWidth="md">
                <PlatformLoadingBlock />
            </PlatformPage>
        )
    }

    return (
        <PlatformPage maxWidth="md">
            <PlatformPageHeader
                title="Edit event"
                subtitle="Update details, categories, payments, and WhatsApp templates."
            />
                <PlatformCard>
                    <Box component="form" onSubmit={handleSubmit}>
                        <Stack spacing={2}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'stretch', sm: 'center' }}>
                                <ReactFileReader multipleFiles={false} handleFiles={handleAddImage} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                                    <Button fullWidth={true} sx={{ ...eventOutlinedButtonSx, width: '100%' }}><UploadIcon /> Upload event image</Button>
                                </ReactFileReader>
                                {image?.name && <Chip label={image.name} onDelete={handleDeleteImage} sx={{ color: marketingColors.p700, bgcolor: marketingColors.p100, border: `1px solid ${marketingColors.p200}` }} />}
                            </Stack>

                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <ReactFileReader multipleFiles={false} handleFiles={handleAddCoverImage} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                                    <Button fullWidth={true} sx={{ ...eventOutlinedButtonSx, width: '100%' }}><UploadIcon /> Upload cover image</Button>
                                </ReactFileReader>
                                {coverImage?.name && <Chip label={coverImage.name} onDelete={handleDeleteCoverImage} sx={{ color: marketingColors.p700, bgcolor: marketingColors.p100, border: `1px solid ${marketingColors.p200}` }} />}
                            </Stack>

                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <ReactFileReader multipleFiles={false} handleFiles={handleAddSponsorsImage} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                                    <Button fullWidth={true} sx={{ ...eventOutlinedButtonSx, width: '100%' }}><UploadIcon /> Upload sponsors image</Button>
                                </ReactFileReader>
                                {sponsorsImage?.name && <Chip label={sponsorsImage.name} onDelete={handleDeleteSponsorsImage} sx={{ color: marketingColors.p700, bgcolor: marketingColors.p100, border: `1px solid ${marketingColors.p200}` }} />}
                            </Stack>

                            <MainInput required fullWidth id="title" label="Event Title" name="title" defaultValue={event?.title} />
                            <MainTextArea required multiline minRows={5} fullWidth name="description" label="Event Description" id="description" defaultValue={event?.description} />

                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <MainInput fullWidth id="artist" label="Event Artist" name="artist" defaultValue={event?.artist} />
                                <MainInput type="datetime-local" fullWidth id="date" label="Event Date" name="date" focused defaultValue={toDatetimeLocalValue(event?.date)} />
                            </Stack>

                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <MainInput type="datetime-local" fullWidth id="deadline" label="Purchase Deadline" name="deadline" focused defaultValue={toDatetimeLocalValue(event?.deadline)} />
                                <MainInput type="datetime-local" fullWidth id="gatesOpenAt" label="Gates Open At" name="gatesOpenAt" focused defaultValue={toDatetimeLocalValue(event?.gatesOpenAt)} />
                            </Stack>

                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <MainInput required fullWidth id="location" label="Event Location" name="location" defaultValue={event?.location} />
                                <MainInput fullWidth type="url" id="locationURL" label="Google Maps URL" name="locationURL" defaultValue={event?.locationURL} />
                            </Stack>

                            <Divider textAlign="left"><Typography sx={eventSectionTitleSx}>Additional requirements</Typography></Divider>
                            {generateRequirements()}
                            <Tooltip title={`Additional data entry requirements when purchasing tickets; \n ex: Instagram Link`}><Button sx={eventOutlinedButtonSx} onClick={handleAdd}>Add data requirement</Button></Tooltip>

                            <Divider textAlign="left"><Typography variant="subtitle2" sx={{ color: 'var(--primaryPurple)', fontWeight: 700 }}>Seating & Categories</Typography></Divider>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <ReactFileReader multipleFiles={false} handleFiles={handleAddChart} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                                    <Button fullWidth={true} sx={{ ...eventOutlinedButtonSx, width: '100%' }}><UploadIcon /> Upload seating chart</Button>
                                </ReactFileReader>
                                {chart?.name && <Chip label={chart.name} onDelete={handleDeleteChart} sx={{ color: marketingColors.p700, bgcolor: marketingColors.p100, border: `1px solid ${marketingColors.p200}` }} />}
                            </Stack>
                            {generateCategories()}
                            <Button sx={eventOutlinedButtonSx} onClick={handleAddCat}>Add category</Button>

                            <Divider />
                            <MainTextArea required fullWidth multiline minRows={5} name="terms" label="Event Terms and Conditions" id="terms" defaultValue={event?.terms} />

                            <MainInput autoFocus fullWidth select labelId='num-label' id={`paymentMethod`} label="Payment Method" value={paymentMethod || event?.paymentMethod || "None"} name={`paymentMethod`} onChange={handlePaymentMethod}>
                                <MenuItem value="Cash">Cash</MenuItem>
                                <MenuItem value="InstaPay">InstaPay</MenuItem>
                                <MenuItem value="FawryPay">FawryPay</MenuItem>
                                <MenuItem value="Paymob">Paymob</MenuItem>
                                <MenuItem value="None">None</MenuItem>
                            </MainInput>
                            {(paymentMethod === "InstaPay" || paymentMethod === "Cash") &&
                                <MainInput required fullWidth type="text" id="paymentAddress" label="Payment Details (Instapay Address / Phone Numbers)" name="paymentAddress" defaultValue={event?.paymentAddress} />}

                            <Divider textAlign="left"><Typography variant="subtitle2" sx={{ color: 'var(--primaryPurple)', fontWeight: 700 }}>How guests get tickets</Typography></Divider>
                            <FormControl component="fieldset" fullWidth sx={{ mb: 2 }}>
                                <RadioGroup value={ticketFlow} onChange={handleTicketFlowChange}>
                                    <FormControlLabel
                                        value="direct"
                                        control={<Radio sx={{ color: marketingColors.p700 }} />}
                                        label="Direct purchase — add to cart or pay online"
                                    />
                                    <FormControlLabel
                                        value="registration"
                                        control={<Radio sx={{ color: marketingColors.p700 }} />}
                                        label="Registration — guests submit a request (optional auto-approve)"
                                    />
                                    <FormControlLabel
                                        value="directInvitation"
                                        control={<Radio sx={{ color: marketingColors.p700 }} />}
                                        label="Direct invitation — send tickets to guests by email"
                                    />
                                    <FormControlLabel
                                        value="invitation"
                                        control={<Radio sx={{ color: marketingColors.p700 }} />}
                                        label="WhatsApp invitation — corporate RSVP flow"
                                    />
                                </RadioGroup>
                            </FormControl>
                            {byRequest && (
                                <>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={autoAccept}
                                                onChange={(e) => setAutoAccept(e.target.checked)}
                                            />
                                        }
                                        label={`Auto-approve registrations${
                                            paymentMethod === "None"
                                                ? " (free — ticket emailed immediately)"
                                                : " (paid — guest proceeds to payment)"
                                        }`}
                                    />
                                    <Alert severity="info" sx={{ mb: 2, mt: 1 }}>
                                        Use the event dashboard → <strong>Registration Page</strong> for a shareable
                                        link. The event can stay private in the marketplace.
                                    </Alert>
                                </>
                            )}
                            {directInvitation && (
                                <Alert severity="info" sx={{ mb: 2 }}>
                                    Use <strong>Send tickets by email</strong> on the event dashboard to deliver tickets to guests.
                                </Alert>
                            )}

                            <Divider textAlign="left"><Typography variant="subtitle2" sx={{ color: 'var(--primaryPurple)', fontWeight: 700 }}>Other settings</Typography></Divider>
                            <FormControlLabel control={<Checkbox checked={isPublic} onChange={(e) => setIsPublic(e.target.checked)} name="public" id="public" />} label="List in public marketplace / browse" />
                            <Tooltip title="Check if this event needs ushers to verify ticket holders name or id before entry"><FormControlLabel control={<Checkbox defaultChecked={event?.needsVerification} name="needsVerification" id="needsVerification" />} label="Needs verification on gate" /></Tooltip>

                            {corporate && (
                                <>
                                    <Divider />
                                    <MainInput fullWidth id="organizer" label="Organized By" name="organizer" defaultValue={event?.organizer} />
                                    <MainTextArea fullWidth required minRows={5} inputProps={{ maxlength: 512 }} name="message" label="Whatsapp Message (512 Characters Max)" id="message" defaultValue={event?.message} />
                                    <FormControlLabel control={<Checkbox checked={hasAttachment} onChange={() => setHasAttachment(!hasAttachment)} name="hasAttachment" id="hasAttachment" />} label="Attachment Message" />

                                    <Divider textAlign="left"><Typography variant="subtitle2" sx={{ color: 'var(--primaryPurple)', fontWeight: 700 }}>WhatsApp templates (Meta names)</Typography></Divider>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        Choose an approved template from the list, enter a custom template name, or leave each as default (none).
                                    </Typography>
                                    <WhatsappEventTemplatePicker label="RSVP invitation template" value={waRsvp} onChange={setWaRsvp} templates={templates} />
                                    <WhatsappEventTemplatePicker label="QR / ticket template" value={waQr} onChange={setWaQr} templates={templates} />
                                    <WhatsappEventTemplatePicker label="Plus one template" value={waPlusOne} onChange={setWaPlusOne} templates={templates} />
                                    <WhatsappEventTemplatePicker label="Reminder template" value={waReminder} onChange={setWaReminder} templates={templates} />
                                    <WhatsappEventTemplatePicker label="Rejection response template" value={waRejection} onChange={setWaRejection} templates={templates} />
                                </>
                            )}

                            {corporate && hasAttachment && (
                                <>
                                    <Divider textAlign="left"><Typography sx={eventSectionTitleSx}>Attachment WhatsApp message</Typography></Divider>
                                    <Typography variant="body2" sx={{ color: marketingColors.gray600, fontFamily: marketingFonts.body }}>
                                        Sent after the ticket QR when this event has an attachment. Uses the built-in &quot;attachment&quot; layout unless you pick a registered template or enter a Meta template name.
                                    </Typography>
                                    <WhatsappEventTemplatePicker label="Attachment message template" value={waAttachment} onChange={setWaAttachment} templates={templates} />
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <ReactFileReader multipleFiles={false} handleFiles={handleAddAttachment} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                                            <Button fullWidth={true} sx={{ ...eventOutlinedButtonSx, width: '100%' }}><UploadIcon /> Upload attachment image</Button>
                                        </ReactFileReader>
                                        {attachment?.name && <Chip label={attachment.name} onDelete={handleDeleteAttachment} sx={{ color: marketingColors.p700, bgcolor: marketingColors.p100, border: `1px solid ${marketingColors.p200}` }} />}
                                    </Stack>
                                    <MainInput fullWidth id="attachmentTitle" label="Attachment Title" name="attachmentTitle" defaultValue={event?.attachmentTitle} />
                                </>
                            )}

                            <PlatformButton type="submit" variant="primary" fullWidth>
                                Save changes
                            </PlatformButton>
                        </Stack>
                    </Box>
                </PlatformCard>
        </PlatformPage>
    );
}


const mapStateToProps = (state) => ({
    user: state?.auth?.user,
    token: state?.auth?.token,
    isLoading: state?.wait?.isLoading,
    isGetLoading: state?.events?.isLoading,
    event: state?.events?.results,
    templates: state?.records?.results?.templates,
});

const mapDispatchToProps = {
    editEvent,
    getEvent,
    getWhatsappTemplates,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditEvent);